<template>
    <div class="card mb-4">
        <table class="table text-center mb-0">
            <tr class="table-primary">
                <!--<th class="text-center border-top-0" style="width: 25%">-->
                    <!--{{ $t('breakdown.header.commission') }}-->
                <!--</th>-->
                <th class="text-center border-top-0" style="width: 25%">
                    <div v-b-tooltip.hover
                         :title="markupTooltip">
                        {{ $t('breakdown.header.agencyMarkup') }}&nbsp;<i class="fa fa-question-circle"></i>
                    </div>
                </th>
                <th class="text-center border-top-0" style="width: 25%">
                    <div v-b-tooltip.hover
                         :title="merchantFeeTooltip">
                        {{ $t('breakdown.header.merchantFee') }}&nbsp;<i class="fa fa-question-circle"></i>
                    </div>
                </th>
                <th class="text-center border-top-0" style="width: 25%">
                    {{ $t('breakdown.header.totalMarkup') }}
                </th>
            </tr>
            <tr>
                <!--<td class="align-middle">-->
                    <!--{{ $t('breakdown.header.commissionTbd') }}-->
                <!--</td>-->
                <td class="align-middle">
                    <div class="input-group">
                        <label for="agency_markup" class="input-group-prepend">
                            <span class="input-group-text">$</span>
                        </label>
                        <input id="agency_markup"
                               class="form-control"
                               type="number"
                               step="0.01"
                               placeholder="0.00"
                               min="0.00"
                               v-model="agencyMarkup"
                               v-validate="'agencyMarkup'"
                               @focus="handleFocusAgencyMarkup"
                               @blur="handleBlurAgencyMarkup"
                               @input="handleInputAgencyMarkup">
                    </div>
                </td>

                <td class="align-middle">
                    <template v-if="calculator.totals.markupMerchantFee > 0">
                        {{ calculator.totals.markupMerchantFee | formatMoney(carPackage.currency) }}
                        + {{ calculator.totals.totalMarkupMerchantFeeTaxTotal | formatMoney(carPackage.currency) }} tax
                    </template>
                    <template v-else>
                        {{ 0 | formatMoney(carPackage.currency) }}
                    </template>
                </td>
                <td class="align-middle">
                    <div class="input-group">
                        <label for="total_markup" class="input-group-prepend">
                            <span class="input-group-text">$</span>
                        </label>
                        <input id="total_markup"
                               class="form-control"
                               type="number"
                               step="0.01"
                               placeholder="0.00"
                               min="0.00"
                               v-model="totalMarkup"
                               @focus="handleFocusTotalMarkup"
                               @blur="handleBlurTotalMarkup"
                               @input="handleInputTotalMarkup">
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: 'price-breakdown-header',
        props: ['carPackage', 'calculator', 'errors'],
        data() {
            return {
                agencyMarkup: '0.00',
                totalMarkup: '0.00',
                agencyMarkupFocused: false,
                totalMarkupFocused: false,
                deferredUpdate: false
            };
        },
        computed: {
            markupTooltip() {
                let limit = window.formatMoney(this.calculator.info.maxMarkupLimit, this.carPackage.currency);
                return this.$t('breakdown.header.maxMarkupTooltip', {markup: limit});
            },
            merchantFeeTooltip() {
                return  this.$t('breakdown.header.merchantFeeTooltip');
            }
        },
        watch: {
            calculator() {
                if (!this.agencyMarkupFocused) {
                    this.agencyMarkup = this.calculator.totals.agencyPayoutMarkup.toFixed(2);
                } else {
                    this.deferredUpdate = true;
                }

                if (!this.totalMarkupFocused) {
                    this.totalMarkup = this.calculator.totals.totalMarkup.toFixed(2);
                } else {
                    this.deferredUpdate = true;
                }
            }
        },
        methods: {
            handleFocusAgencyMarkup(e) {
                if (!this.agencyMarkupFocused) {
                    setTimeout(function () { e.target.select(); }, 50);
                }
                this.agencyMarkupFocused = true;
            },
            handleFocusTotalMarkup(e) {
                if (!this.totalMarkupFocused) {
                    setTimeout(function () { e.target.select(); }, 50);
                }
                this.totalMarkupFocused = true;
            },
            handleBlurAgencyMarkup() {
                this.agencyMarkupFocused = false;
                if (this.deferredUpdate) {
                    this.deferredUpdate = false;
                    this.agencyMarkup = this.calculator.totals.agencyPayoutMarkup.toFixed(2);
                }
            },
            handleBlurTotalMarkup() {
                this.totalMarkupFocused = false;
                if (this.deferredUpdate) {
                    this.deferredUpdate = false;
                    this.totalMarkup = this.calculator.totals.totalMarkup.toFixed(2);
                }
            },
            handleInputAgencyMarkup() {
                this.$emit('agency-markup-changed', this.agencyMarkup);
            },
            handleInputTotalMarkup() {
                this.$emit('total-markup-changed', this.totalMarkup);
            }
        }
    };
</script>

<style scoped>

</style>